import angular from 'angular';
import indexMetricQuerycache from './index-metric-querycache.component';

export default angular.module('eshq.indexMetricQuerycache', [])
  .component('eshqIndexMetricQuerycache', indexMetricQuerycache)
  .name;



// WEBPACK FOOTER //
// ./ui/src/components/index-metric-querycache/index-metric-querycache.js